import ReconnectingWebSocket from 'reconnecting-websocket';
import {
  getUserListSuccess as setInterviewUserList,
  getGroupListSuccess as setInterviewGroupList,
  getStageId as setStageId,
  updateCurUser as setCurUser,
  updateCurUserScore as SetCurUserScore,
  clearUserList,
  clearLoadGroupList,
} from 'slice/stage';
import { setOnline } from 'slice/ws';
import {
  getGroupDataSuccess as setInterviewTimeList,
  getPanelListSuccess as setPhaseTaskList,
} from 'slice/panel';
import { setEditInfo as setInterviewUser } from 'slice/apply';

import {
  setScoreList,
  updateScore as setUserScore,
  updateComment as setUserComment,
  addUserScore,
  setResetPost,
} from 'slice/score';
import { isEmpty } from 'underscore';

const beforeCallActions = {
  'interview_group/get_list': () => setInterviewGroupList([]),
  'interview_time/get': () => setInterviewTimeList(null),
  'interview_phase_task/get_list': () => setPhaseTaskList([]),
  'interview_phase_user/get_list': () => clearUserList(),
  // 'interview_user/get': () => setInterviewUser(null),
  'score/get_list': () => setScoreList([]),
};

const actions = {
  'connection/switch-channel': setStageId,
  'connection/ping': (payload) => {
    const ms = Date.now() - payload;
    return setOnline({ ms });
  },
  'interview/add_interview_user': ({ post }) => ({
    type: 'interview_user/get',
    payload: { ns_user_id: post.ns_user_id, phase_id: post.phase_id },
  }),
  'interview/sign_in': ({ state, data, post }) => {
    console.log('current user :', state?.apply?.editInfo?.ns_user_id);
    return state?.apply?.editInfo?.ns_user_id === post.ns_user_id &&
      state?.apply?.editInfo?.phase_id === post.phase_id
      ? {
          type: 'interview_user/get',
          payload: { ns_user_id: post.ns_user_id, phase_id: post.phase_id },
        }
      : {
          type: 'stage/updateCurUser',
          payload: data,
        };
  },
  'time/reset_attend': ({ state, data, post }) => {
    console.log('current user :', state?.apply?.editInfo);
    return state?.apply?.editInfo?.ns_user_id === post.ns_user_id &&
      state?.apply?.editInfo?.phase_id === post.phase_id
      ? {
          type: 'interview_user/get',
          payload: { ns_user_id: post.ns_user_id, phase_id: post.phase_id },
        }
      : {
          type: 'stage/updateCurUser',
          payload: data,
        };
  },
  'interview_user/get': [setInterviewUser, setCurUser],
  'interview_phase_user/get_list': setInterviewUserList,
  'interview_group/get_list': setInterviewGroupList,
  'interview_time/get': setInterviewTimeList,
  'interview_phase_task/get_list': setPhaseTaskList,
  'score/get_list': setScoreList,
  'score/set_score': setUserScore,
  'score/set_comment': setUserComment,
  'score/add_score': [addUserScore, SetCurUserScore],
  'score/reset': setResetPost,
  'connection/connect': () => ({
    type: 'connect/fulfilled',
  }),
};

const ws = (store) => {
  console.log('init websocket :', process.env.REACT_APP_WS_URL);
  const websocket = new ReconnectingWebSocket(
    `${process.env.REACT_APP_WS_URL}`
  );

  let firstCall = false;
  let pingInterval = null;
  let timeoutId = null;

  const autoPingTest = () => {
    const ping = () => {
      websocket.send(
        btoa(
          JSON.stringify({
            action: 'connection/ping',
            data: Date.now(),
          })
        )
      );
    };
    // ping();
    pingInterval = setInterval(() => {
      if (firstCall) {
        ping();

        timeoutId = setTimeout(() => {
          console.log('connection timeout');
          store.dispatch(setOnline({ ms: 1500 }));
        }, 1500);
      }
    }, 3 * 1000);
  };

  /**
   * Connection initialize
   */
  websocket.addEventListener('open', () => {
    console.log('[open] Connection established :', firstCall);
    const state = store.getState();
    if (window.localStorage.getItem('accessToken') && !firstCall) {
      websocket.send(
        btoa(
          JSON.stringify({
            action: 'connection/connect',
            data: {
              access_token: window.localStorage.getItem('accessToken'),
              device_id: window.localStorage.getItem('uuid'),
              channel: state?.stage?.currentPhase?.display_id,
            },
          })
        )
      );
      firstCall = true;
      autoPingTest();
    }
  });

  websocket.addEventListener('close', () => {
    console.log('[close] Connection established :', firstCall);
    // store.dispatch(setOnline('failed'));
    if (pingInterval) {
      clearInterval(pingInterval);
      pingInterval = null;
    }
    firstCall = false;
  });

  /**
   * Message Handler
   */
  websocket.addEventListener('message', (event) => {
    try {
      const ret = JSON.parse(
        Buffer.from(event.data, 'base64').toString('utf-8')
      );
      console.log('received :', ret);
      const { result, action, data, post, ...others } = ret;
      if (action === 'connection/ping' && timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      if (
        parseInt(result, 10) === 1 &&
        Object.keys(actions).indexOf(action) > -1
      ) {
        const callback = actions[action];
        const state = store.getState();

        if (Array.isArray(callback)) {
          callback.forEach((item) => {
            if (post) {
              store.dispatch(item({ data, state, post, ...others }));
              return;
            }
            store.dispatch(item(data));
          });
        } else if (post) {
          store.dispatch(callback({ data, state, post, ...others }));
        } else {
          store.dispatch(callback(data));
        }
      } else {
        console.log(
          'throw error',
          parseInt(result, 10) === 1,
          Object.keys(actions).indexOf(ret?.action) > -1
        );
        throw ret;
      }
    } catch (error) {
      console.log('[Unexcepted message] ', error);
      if (error?.action === 'interview_group/get_list') {
        store.dispatch(clearLoadGroupList());
      }
    }
  });

  return websocket;
};

const WebsocketWithStore = (store) => {
  const websocket = ws(store);

  return (next) => async (action) => {
    if (action?.type === 'connection/connect') {
      if (websocket.readyState >= ReconnectingWebSocket.CLOSING) {
        websocket.reconnect();
      }
      websocket.send(
        btoa(
          JSON.stringify({
            action: action.type,
            data: {
              access_token: window.localStorage.getItem('accessToken'),
              device_id: window.localStorage.getItem('uuid'),
            },
          })
        )
      );
      return next(action);
    }
    if (action?.type === 'USER/LOGOUT') {
      websocket.close();
    }
    if (
      action?.type &&
      Object.keys(beforeCallActions).indexOf(action?.type) > -1
    ) {
      try {
        const payload = beforeCallActions[action?.type]();
        if (!isEmpty(payload)) {
          next(payload);
        }
      } catch (error) {
        console.log('before call action : error!');
      }
    }
    if (!!action?.type && Object.keys(actions).indexOf(action?.type) > -1) {
      // const isConnectionEstablished = readyState === ReadyState.OPEN;
      console.log('emit action:', action);
      websocket.send(
        Buffer.from(
          JSON.stringify({
            action: action.type,
            data: {
              ...action.payload,
              merchant_id: window.localStorage.getItem('merchant_id'),
            },
          })
        ).toString('base64')
      );
      return next({ type: 'call-websocket-api', payload: action });
    }
    return next(action);
  };
};

export default WebsocketWithStore;
